import { ToastMessage } from "../../components/ToastMessage/ToastMessage";
import { Header } from "../Header/Header";
import { ResetPasswordFirstLogin } from "../ResetPassword/ResetPasswordFirstLogin";

export const Layout = (props: any) => {
    return (
        <div id="layout">
            <ResetPasswordFirstLogin />
            <ToastMessage />
            <Header />
            <main className="main">{props.children}</main>
        </div>
    );
};
